import React, { useState } from 'react';
import baseURL from '../../url';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSave } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

export default function NewCategoriaGastoModal({ isOpen, onClose, onCategoriaCreada }) {
    const [nombreCategoria, setNombreCategoria] = useState('');
    const [guardando, setGuardando] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!nombreCategoria.trim()) {
            toast.warn('Escribe el nombre de la categoría');
            return;
        }

        setGuardando(true);
        try {
            const res = await fetch(`${baseURL}/categoriaGastoPost.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ categoria: nombreCategoria.trim() })
            });
            const data = await res.json();
            setGuardando(false);

            if (data.mensaje) {
                Swal.fire({
                    title: '¡Categoría creada!',
                    text: `La categoría "${nombreCategoria}" ha sido agregada con éxito`,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setNombreCategoria('');
                if (onCategoriaCreada) onCategoriaCreada();
                onClose();
            } else {
                toast.error(data.error || 'No se pudo crear la categoría');
            }
        } catch (err) {
            setGuardando(false);
            console.error(err);
            toast.error('Error de red al crear la categoría');
        }
    };

    return (
        <div className="modalGastoOverlay">
            <div className="modalGastoContent modalCatContent">
                <div className="modalGastoTop">
                    <h3>🏷️ Nueva Categoría de Gasto</h3>
                    <button className="btnCloseModalGasto" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="formGasto">
                    <div className="formField">
                        <label>Nombre de la Categoría:</label>
                        <input
                            type="text"
                            placeholder="Ej: Publicidad y Marketing, Alquiler, etc."
                            value={nombreCategoria}
                            onChange={(e) => setNombreCategoria(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>

                    <div className="modalGastoActions">
                        <button type="button" className="btnCancelarGasto" onClick={onClose} disabled={guardando}>
                            Cancelar
                        </button>
                        <button type="submit" className="btnGuardarGasto" disabled={guardando}>
                            <FontAwesomeIcon icon={faSave} /> {guardando ? 'Guardando...' : 'Guardar Categoría'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
